
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class SubmenuProfile extends Vue {
  @Prop() private score!: Number;
  options = [
    {
      title: "Mis Postulaciones",
      img: require("@/./assets/icons/postulation-icon.svg"),
      id: "option1",
      link: "/postulaciones"
    },
    {
      title: "Ofertas Guardadas",
      img: require("@/./assets/icons/save-icon.svg"),
      id: "option2",
      link: "/ofertas-guardadas"
    } /*,
    {
      title: "Mensajes",
      img: require("@/./assets/icons/message-icon.svg"),
      id: "option3",
      link: "/mensajes"
    }*/
  ];
}
